import { extractResource } from "../../../../helper/extractResource";

export interface CheckInStatusForCardProps {
  checkedInCount: number;
  totalPassengerCount: number;
  resourceData: Record<string, string>;
}
export function CheckInStatusForCard({ checkedInCount, totalPassengerCount, resourceData }: CheckInStatusForCardProps) {
  if (checkedInCount !== totalPassengerCount && checkedInCount !== 0) {
    return (
      <p className="m-0 font-normal text-xs flex items-center pt-2 text-gray-700 ml-2">
        <img src="/svg/delayed_icon_gray.svg" alt="time lapse" />
        &nbsp;
        {checkedInCount}/{totalPassengerCount}&nbsp;
        {extractResource(resourceData, "checkedin")}
      </p>
    );
  }
  if (checkedInCount === totalPassengerCount) {
    return (
      <div className="flex flex-row items-center ml-2">
        <img src="/svg/CheckCircleSolid.svg" alt="checked circle" />
        <div className="font-medium text-xs text-typography-success pt-2 pb-1">
          {extractResource(resourceData, "checkedin")}
        </div>
      </div>
    );
  }
  return <div />;
}
